import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';  
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';
@Injectable({
  providedIn: 'root'
})
export class OfficerscompanyService {
 // CompanyapiUrl = this.ConfigService.getAPIBaseUrl() + 'api/CompanyInformation/';
  URL = this.ConfigService.getAPIBaseUrl() + 'api/AccountsOfficersOfTheCompany/';
 // URL: any = 'https://localhost:44306/api/AccountsOfficersOfTheCompany/'; 
  constructor(public HttpClient: HttpClient, private ConfigService: ConfigurationService) { }


  //SaveOfficerscompany(accounts) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "InsertOfficersOfTheCompany", accounts)
  //}
  SaveOfficerscompanyGrid(accounts) {  //using
    debugger;
    return this.HttpClient.post(this.URL + "InsertOfficersOfTheCompany", accounts)
  }
  GetAllOfficerscompany() {
    debugger;
    return this.HttpClient.get(this.URL + "GetOfficersOfTheCompany")
  }
  GetOneOfficerscompany(APPeriodId) {  //using
    debugger;
    return this.HttpClient.get(this.URL + "GetOfficersOfTheCompany?APPeriodId=" + APPeriodId)
  }
  Getofficers_CH() {  
    debugger;
    var companyNumber = localStorage.getItem('companyRegistrationNumber');
    return this.HttpClient.get(`${this.URL}Getofficers_CH/${companyNumber}`);
  }

  //GetParticularCompanyDataBYNo(RegNo) {
  //  debugger
  //  return this.HttpClient.get(this.CompanyapiUrl + 'GetOfficersAsync/' + RegNo)
  //}


  //DeleteOfficerscompany(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "DeleteOfficerscompany", id)
  //}
  //SaveOfficerscompanyGridDetails(data) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "InsertOfficersOfTheCompany", data)
  //}
  //GetAllOfficerscompanyGridDetails() {
  //  debugger;
  //  return this.HttpClient.get(this.URL + "GetALLOfficersOfTheCompanyGridDetails")
  //}
  //GetOneOfficerscompanyGridDetails(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "GetOfficersOfTheCompanyGridDetails", id)
  //}
  //DeleteOfficerscompanyGridDetails(id) {
  //  debugger;
  //  return this.HttpClient.post(this.URL + "DeleteOfficerscompany", id)
  //}
}

